module.exports = __webpack_public_path__ + "static/media/No_policies.432ba86f.png";